<template>
  <main>
    <div v-if="!loading">
      <div class="container-fluid p-0 mt-0">
        <section id="carousel" v-if="showCarousel && listaCarrosel && listaCarrosel.length">
          <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :loop="true" :transition="1000">
            <slide v-for="(slide, index) of listaCarrosel" :key="index">
              <img @click="clickBanner(slide)" :src="slide.urlImageWeb" style="width: 100%; object-fit: cover;"
                class="banner" />
            </slide>
          </carousel>
        </section>
      </div>

      <div class="container-fluid mt-3" style="width: 100%;max-width: 1200px;">
        <div class="grid-pesquisa">
          <form class="input-group flex-nowrap" v-on:submit.prevent="getOffersByFilters()">
            <input class="w-100 form-control-lg" aria-label="Large" type="search" placeholder="O que você procura?"
              v-model="search" />
            <button class="btn_selecionar item_produto pl-3 pr-3" style="border: none;font-size:1.2em">
              Pesquisar
            </button>
          </form>
          <div class="mt-2">
            <span class="text-danger">{{ erro }}</span>
          </div>
        </div>
      </div>

      <div class="container-fluid mt-3" style="width: 100%;max-width: 1200px;">
        <div class="a-divider a-divider-break"></div>
        <div class="justify-content-center" v-if="this.categorias">
          <carousel :per-page="1" :perPageCustom="pageCustom()" :mouse-drag="true" :autoplay="false" :loop="true"
            :speed="500">
            <slide>
              <div>
                <div class="col text-center">
                  <a href="#" @click="getOffers()">
                    <img class="rounded-circle circle-categoria"
                      src="https://pagglo-cdn.s3.amazonaws.com/app/rede/vtgcb/loja/logo/eb6c1711-21de-4e65-93e5-86b2c52cf662.png" />
                  </a>
                  <br />
                  <span style="font-size:12px;">Todas</span>
                </div>
              </div>
            </slide>
            <slide v-for="(item, index) of this.categorias" :key="index">
              <div>
                <div class="col text-center">
                  <a href="#" @click="getOffersByCategoryId(item.id)">
                    <img class="rounded-circle circle-categoria" :src="item.urlIcon" />
                  </a>
                  <br />
                  <span style="font-size:12px;">{{ item.name }}</span>
                </div>
              </div>
            </slide>
          </carousel>

        </div>

        <div class="a-divider a-divider-break mt-2"></div>
        <div class="row m-3" v-if="erro">
          <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
            {{ erro }}
          </div>
        </div>
        <div class="products">
          <div class="pagina-carousel">
            <div class="card mt-3" v-for="(item, index) of descontos" :key="index">
              <div class="card-body">
                <h3 class="categoria-produto" :id="item.category.id">
                  <i>
                    <img :src="item.category.urlIcon" width="16" height="16" class="bi" />
                  </i>
                  <span class="categoria-produto">{{ item.category.name }}</span>
                  <span class="d-none">{{ item.category.id }}</span>
                  <span class="float-right">
                    <a @click="openCategory(item.category.id)">
                      <small>Ver mais</small>
                    </a>
                  </span>
                </h3>
                <div class="container-carousel">
                  <div class="corpo-carousel">
                    <carousel :nav="false" :dots="false" :responsive="responsiveCarrocel()">
                      <div v-for="offer of item.offers" :key="offer.id">
                        <div class="carousel" >
                        <div class="card-item-carousel cursor" @click="openOffer(offer.id)">
                          <div class="foto-protudo"
                            v-bind:style="{ 'background-image': 'url(' + imagemOffer(offer.urlImage) + ')' }">
                          </div>
                          <div class="carousel-texto">
                            <div class="descricao-protudo mt-1"><strong> {{ offer.title }}</strong></div>
                            <div class="preco-protudo mt-2">{{ offer.benefitsText }}</div>
                          </div>
                        </div>
                      </div>
                      </div>
                    
                    </carousel>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>

import Loading from "@/components/Loading.vue";

import { authApp, authUser } from "../service/clube/serviceAuthAPI";
import {
  getAds,
  getCategories,
  getOffersHome,
  getOffersByCategoryId,
  getOffersByFilters
} from "../service/clube/serviceClubeAPI";


export default {
  name: "ClubeDescontoNew",
  components: { Loading },
  data() {
    return {
      erro: "",
      loading: false,
      descontos: null,
      categorias: [],
      showCarousel: true,
      search: "",
      listaCarrosel: [],
    };
  },
  mounted() {
    this.loading = true
    let userCode = this.$route.query.userCode ? this.$route.query.userCode : localStorage.getItem("accessToken");

    authApp().then(auth => {
      if (auth.code === "200") {
        localStorage.removeItem("token_api_sso");
        localStorage.setItem("token_api_sso", auth.data.token);
        if (userCode) {
          const user = { grantType: "access_token", userCode: userCode };

          authUser(user).then(authUser => {
            if (authUser.code === "200") {
              localStorage.removeItem("token_api_sso");
              localStorage.setItem("token_api_sso", authUser.data.token);
              this.getAds();
              this.getCategories();
              this.getOffers();
            } else {
              this.getAds();
              this.getCategories();
              this.getOffers();
            }
          }).catch(error => {
            this.erro = `500 - ${error.data}`;
          })
        } else {
          this.getAds();
          this.getCategories();
          this.getOffers();
        }
      }
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.refreshCarousel)
  },

  methods: {
    responsiveCarrocel() {
      return {
        0: {
          items: 2.5,
        },
        660: {
          items: 3.5,
        },
        1024: {
          items: 4,
        },
        1200: {
          items: 4.5,
        },
        1400: {
          items: 5.5,
        },
      }
    },
    pageCustom() {
      return [
        [300, 5],
        [500, 8],
        [800, 10],
        [1200, 12]
      ]
    },
    openOffer(id) {
      const route = this.$route.path;
      this.$router.push(`${route}/${id}`)
    },
    imagemOffer(imagem) {
      if (imagem === null) return 'https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png';
      return imagem;
    },
    getAds() {
      this.erro = "";
      this.loading = true
      getAds().then(ad => {
        if (ad.code === '200') {
          window.addEventListener('resize', this.refreshCarousel)
          this.listaCarrosel = ad.data.filter(item => item.urlImageWeb && item.urlImageWeb !== "");
          this.loading = false
        }
      }).catch(error => {
        this.erro = `500 - ${error.data}`;
      })
    },
    getCategories() {
      this.erro = "";
      this.loading = true
      getCategories().then(cat => {
        if (cat.code === '200') {
          this.categorias = cat.data;
          this.loading = false
        }
      }).catch(error => {
        this.erro = `500 - ${error.data}`;
      })
    },
    getOffers() {
      this.erro = "";
      this.loading = true
      getOffersHome().then(offer => {
        if (offer.code === '200') {
          this.descontos = offer.data;
          this.loading = false
        }
      }).catch(error => {
        this.erro = `500 - ${error.data}`;
      })
    },

    getOffersByCategoryId(id) {
      this.erro = "";
      this.loading = true
      getOffersByCategoryId(id).then(offer => {
        if (offer.code === '200') {
          this.descontos = offer.data;
          this.loading = false
        }
      }).catch(error => {
        this.erro = `500 - ${error.data}`;
      })
    },
    getOffersByFilters() {
      this.erro = "";
      this.loading = true
      getOffersByFilters({ search: this.search }).then(offer => {
        if (offer.code === '200') {
          this.descontos = offer.data;
        } else {
          this.erro = `${offer.code} - ${offer.message}`;
        }
        this.loading = false
      }).catch(error => {
        this.erro = `500 - ${error.data}`;
      })
    },
    urlImage(imagemUrl) {
      return `url('${imagemUrl ||
        "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png"}')`;
    },

    clickBanner(slide) {
      if (slide.actionSettings) {
        window.open(slide.actionSettings.pathParams.url, '_blank')
      }
    },
    refreshCarousel() {
      this.showCarousel = false
      setTimeout(() => (this.showCarousel = true), 100)
    },
    openCategory(id) {
      const route = this.$route.path;
      this.$router.push(`${route}/categoria/${id}`)
    },
  }
};
</script>
<style scoped lang="scss">
.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-principal);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}

.card {
  background-color: var(--cor-home-card) !important;
}

h3.categoria-produto {
  font-size: 1rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  color: var(--cor-secundaria) !important;
  font-weight: 700;
}

span.categoria-produto {
  margin-left: 8px;
}

img.bi {
  margin-top: -2px;
}

img {
  border-radius: 20px;
}

.cursor {
  cursor: pointer;
}

.circle-categoria {
  background-color: var(--cor-secundaria);
  max-width: 40px;
}


.card-item-carousel {
  background-color: var(--cor-home-card) !important;
  color: var(--cor-home-texto-card-item) !important;
  border: 1px solid #ececec;
  border-radius: 8px;
  height: 275px;
  width: 195px;
}

.card-item-carousel:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, .2) !important;
}

.owl-stage-outer {
  padding: 10px 0px;
}

.foto-protudo {
  width: 100%;
  min-height: 140px;
  background-size: cover;
  background-position: center;
  -webkit-border-top-left-radius: 8px;
  -webkit-border-top-right-radius: 8px;
  -moz-border-radius-topleft: 8px;
  -moz-border-radius-topright: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.container-fluid {
  .banner {
    padding: 15px;
  }
}

.carousel {
  width: 100%;
  padding: 5px;
}

.corpo-carousel {
  width: calc(100% - 10px);
  display: inline-block;
}

.carousel-texto {
  padding: 15px;
  margin-top: -20px;
  text-align: center;
}

.card-item-carousel {
  max-height: 340px;
  margin-bottom: 15px;
}

.owl-item.active {
  margin-right: 10px;
}


@media (max-width: 770px) {

  .owl-item.active {
    margin-right: 5px;
  }

  .descricao-protudo {
    font-size: 0.85rem;
  }

  .carousel-texto {
    padding: 5px;
  }

  .preco-protudo {
    font-size: 0.85rem;
  }

  .unidade-protudo {
    font-size: 0.75rem;
  }

  .foto-protudo {
    min-height: 110px;
    max-width: 110px;
  }

  .card-body {
    padding: 0.1rem;
  }

  .card-item-carousel {
    height: 218px;
    width: 136px;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .categoria-produto {
    padding-left: 10px;
    margin-top: 5px;
  }

  .carousel {
    padding: 0px;
  }

  .carousel-texto {
    padding: 10px;
  }


}
</style>
